'use strict';

function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqualArrays;



/*****************
 ** WEBPACK FOOTER
 ** ./~/shallow-equal/arrays/index.js
 ** module id = 1362
 ** module chunks = 0
 **/